var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ui stackable grid" }, [
    _c(
      "div",
      { staticClass: "eight wide column" },
      [
        _c("h3", [_vm._v("立候補申請")]),
        _vm._v(" "),
        _vm.candidate
          ? _c("candidate-detail", { attrs: { candidate: _vm.candidate } })
          : _c(
              "form",
              {
                staticClass: "ui form",
                class: { warning: _vm.postForm.hasErrors() },
              },
              [
                _c("div", { staticClass: "fields" }, [
                  _c(
                    "div",
                    { staticClass: "required field" },
                    [
                      _c("label", [_vm._v("担当者名(必須)")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.postForm.model.operator_name,
                            expression: "postForm.model.operator_name",
                          },
                        ],
                        attrs: { type: "text" },
                        domProps: { value: _vm.postForm.model.operator_name },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.postForm.model,
                              "operator_name",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("validation-message", {
                        attrs: { form: _vm.postForm, field: "operator_name" },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "required field" },
                  [
                    _c("label", [_vm._v("お客様向け立候補コメント(必須)")]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.postForm.model.message,
                          expression: "postForm.model.message",
                        },
                      ],
                      domProps: { value: _vm.postForm.model.message },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.postForm.model,
                            "message",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("validation-message", {
                      attrs: { form: _vm.postForm, field: "message" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "ui fluid accordion",
                    staticStyle: { "margin-bottom": "20px" },
                  },
                  [
                    _c("div", { staticClass: "title active" }, [
                      _c("i", { staticClass: "dropdown icon" }),
                      _vm._v(" お客様に提案するコース情報を入力する\n        "),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "content active" }, [
                      _c("div", { staticClass: "ui positive message" }, [
                        _vm._v(
                          "\n          普段とは違う特別なコース内容でご提案するとお客様に選ばれやすくなります\n          "
                        ),
                        _vm.canChoosePlan
                          ? _c("span", [
                              _c("br"),
                              _vm._v(
                                "登録済みのコース情報をコピーしていただくとスムーズに入力できます。"
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _vm.canChoosePlan
                        ? _c(
                            "div",
                            { staticStyle: { "margin-bottom": "10px" } },
                            [
                              _vm.shop && _vm.shop.courses.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "ui checkbox radio" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.selectedPlanType,
                                            expression: "selectedPlanType",
                                          },
                                        ],
                                        attrs: {
                                          type: "radio",
                                          id: "courses",
                                          name: "plan_type",
                                        },
                                        domProps: {
                                          value:
                                            _vm.consts.PLAN_TYPE_TO_VALUE
                                              .course,
                                          checked: _vm._q(
                                            _vm.selectedPlanType,
                                            _vm.consts.PLAN_TYPE_TO_VALUE.course
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.selectedPlanType =
                                              _vm.consts.PLAN_TYPE_TO_VALUE.course
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticStyle: { cursor: "pointer" },
                                          attrs: { for: "courses" },
                                        },
                                        [_vm._v("宴会")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.shop && _vm.shop.meetings.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "ui checkbox radio" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.selectedPlanType,
                                            expression: "selectedPlanType",
                                          },
                                        ],
                                        attrs: {
                                          type: "radio",
                                          id: "meetings",
                                          name: "plan_type",
                                        },
                                        domProps: {
                                          value:
                                            _vm.consts.PLAN_TYPE_TO_VALUE
                                              .meeting,
                                          checked: _vm._q(
                                            _vm.selectedPlanType,
                                            _vm.consts.PLAN_TYPE_TO_VALUE
                                              .meeting
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.selectedPlanType =
                                              _vm.consts.PLAN_TYPE_TO_VALUE.meeting
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticStyle: { cursor: "pointer" },
                                          attrs: { for: "meetings" },
                                        },
                                        [_vm._v("会議室")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.shop && _vm.shop.lodge_meetings.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "ui checkbox radio" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.selectedPlanType,
                                            expression: "selectedPlanType",
                                          },
                                        ],
                                        attrs: {
                                          type: "radio",
                                          id: "lodge-meetings",
                                          name: "plan_type",
                                        },
                                        domProps: {
                                          value:
                                            _vm.consts.PLAN_TYPE_TO_VALUE
                                              .lodgeMeeting,
                                          checked: _vm._q(
                                            _vm.selectedPlanType,
                                            _vm.consts.PLAN_TYPE_TO_VALUE
                                              .lodgeMeeting
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.selectedPlanType =
                                              _vm.consts.PLAN_TYPE_TO_VALUE.lodgeMeeting
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticStyle: { cursor: "pointer" },
                                          attrs: { for: "lodge-meetings" },
                                        },
                                        [_vm._v("宿泊会議")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.canChoosePlan
                        ? _c("div", { staticClass: "fields" }, [
                            _c(
                              "div",
                              { staticClass: "ten wide field" },
                              [
                                _vm.selectedPlanType ===
                                _vm.consts.PLAN_TYPE_TO_VALUE.course
                                  ? _c(
                                      "dropdown",
                                      {
                                        attrs: {
                                          placeholder:
                                            "--- コピーするコース情報を選択 ---",
                                        },
                                        model: {
                                          value: _vm.selectedCourseId,
                                          callback: function ($$v) {
                                            _vm.selectedCourseId = $$v
                                          },
                                          expression: "selectedCourseId",
                                        },
                                      },
                                      _vm._l(
                                        _vm.shop.courses,
                                        function (course) {
                                          return _c(
                                            "option",
                                            {
                                              key:
                                                _vm.consts.PLAN_TYPE_TO_VALUE
                                                  .course + course.id,
                                              domProps: { value: course.id },
                                            },
                                            [_vm._v(_vm._s(course.name))]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm.selectedPlanType ===
                                    _vm.consts.PLAN_TYPE_TO_VALUE.meeting
                                  ? _c(
                                      "dropdown",
                                      {
                                        attrs: {
                                          placeholder:
                                            "--- コピーするコース情報を選択 ---",
                                        },
                                        model: {
                                          value: _vm.selectedMeetingId,
                                          callback: function ($$v) {
                                            _vm.selectedMeetingId = $$v
                                          },
                                          expression: "selectedMeetingId",
                                        },
                                      },
                                      _vm._l(
                                        _vm.shop.meetings,
                                        function (meeting) {
                                          return _c(
                                            "option",
                                            {
                                              key:
                                                _vm.consts.PLAN_TYPE_TO_VALUE
                                                  .meeting + meeting.id,
                                              domProps: { value: meeting.id },
                                            },
                                            [_vm._v(_vm._s(meeting.name))]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm.selectedPlanType ===
                                    _vm.consts.PLAN_TYPE_TO_VALUE.lodgeMeeting
                                  ? _c(
                                      "dropdown",
                                      {
                                        attrs: {
                                          placeholder:
                                            "--- コピーするコース情報を選択 ---",
                                        },
                                        model: {
                                          value: _vm.selectedLodgeMeetingId,
                                          callback: function ($$v) {
                                            _vm.selectedLodgeMeetingId = $$v
                                          },
                                          expression: "selectedLodgeMeetingId",
                                        },
                                      },
                                      _vm._l(
                                        _vm.shop.lodge_meetings,
                                        function (lodgeMeeting) {
                                          return _c(
                                            "option",
                                            {
                                              key:
                                                _vm.consts.PLAN_TYPE_TO_VALUE
                                                  .lodgeMeeting +
                                                lodgeMeeting.id,
                                              domProps: {
                                                value: lodgeMeeting.id,
                                              },
                                            },
                                            [_vm._v(_vm._s(lodgeMeeting.name))]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "ui tiny teal button",
                                attrs: { type: "button" },
                                on: { click: _vm.copyCourse },
                              },
                              [
                                _c("i", {
                                  staticClass: "arrow down large icon",
                                }),
                                _vm._v("コース内容をコピーする"),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "ui grid fields" }, [
                        _c(
                          "div",
                          { staticClass: "eight wide column field" },
                          [
                            _c("label", [_vm._v("価格(税込)")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "ui right labeled input" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.postForm.model.price,
                                      expression: "postForm.model.price",
                                    },
                                  ],
                                  attrs: {
                                    type: "number",
                                    placeholder: "4000",
                                  },
                                  domProps: { value: _vm.postForm.model.price },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.postForm.model,
                                        "price",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("label", { staticClass: "ui label" }, [
                                  _vm._v("円"),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("validation-message", {
                              attrs: { form: _vm.postForm, field: "price" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "eight wide column field" },
                          [
                            _c("label", [_vm._v("品数")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "ui right labeled input" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.postForm.model.dish_count,
                                      expression: "postForm.model.dish_count",
                                    },
                                  ],
                                  attrs: { type: "number", placeholder: "8" },
                                  domProps: {
                                    value: _vm.postForm.model.dish_count,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.postForm.model,
                                        "dish_count",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("label", { staticClass: "ui label" }, [
                                  _vm._v("品"),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("validation-message", {
                              attrs: {
                                form: _vm.postForm,
                                field: "dish_count",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "field" }, [
                        _c("label", [_vm._v("コース詳細")]),
                        _vm._v(" "),
                        _vm.selectedPlanType ===
                        _vm.consts.PLAN_TYPE_TO_VALUE.course
                          ? _c(
                              "div",
                              [
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.postForm.model.course_detail,
                                      expression:
                                        "postForm.model.course_detail",
                                    },
                                  ],
                                  attrs: { rows: "12" },
                                  domProps: {
                                    value: _vm.postForm.model.course_detail,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.postForm.model,
                                        "course_detail",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("validation-message", {
                                  attrs: {
                                    form: _vm.postForm,
                                    field: "course_detail",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.selectedPlanType ===
                        _vm.consts.PLAN_TYPE_TO_VALUE.meeting
                          ? _c(
                              "div",
                              [
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.postForm.model.meeting_detail,
                                      expression:
                                        "postForm.model.meeting_detail",
                                    },
                                  ],
                                  attrs: { rows: "12" },
                                  domProps: {
                                    value: _vm.postForm.model.meeting_detail,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.postForm.model,
                                        "meeting_detail",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("validation-message", {
                                  attrs: {
                                    form: _vm.postForm,
                                    field: "meeting_detail",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.selectedPlanType ===
                        _vm.consts.PLAN_TYPE_TO_VALUE.lodgeMeeting
                          ? _c(
                              "div",
                              [
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.postForm.model.lodge_meeting_detail,
                                      expression:
                                        "postForm.model.lodge_meeting_detail",
                                    },
                                  ],
                                  attrs: { rows: "12" },
                                  domProps: {
                                    value:
                                      _vm.postForm.model.lodge_meeting_detail,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.postForm.model,
                                        "lodge_meeting_detail",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("validation-message", {
                                  attrs: {
                                    form: _vm.postForm,
                                    field: "lodge_meeting_detail",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "ui stackable grid" }, [
                  _c("div", { staticClass: "five wide column" }, [
                    _c(
                      "button",
                      {
                        staticClass: "ui primary large button",
                        class: { loading: _vm.postForm.waiting },
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.post.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("立候補する")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "eleven wide column" }, [
                    _c(
                      "button",
                      {
                        staticClass: "ui large button",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openPreview.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("入力した内容をプレビュー表示する")]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "ui modal",
                    attrs: { id: "candidatePreview" },
                  },
                  [
                    _c("i", { staticClass: "close icon" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "header" }, [
                      _vm._v("お客様画面のプレビュー"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "scrolling content" },
                      [
                        _c("div", { staticClass: "ui positive message" }, [
                          _vm._v("お客様に以下の内容が表示されます。"),
                        ]),
                        _vm._v(" "),
                        _c("candidate-detail", {
                          attrs: {
                            candidate: _vm.postForm.model,
                            "plan-type": _vm.selectedPlanType,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "actions" }, [
                      _c("button", { staticClass: "ui cancel button" }, [
                        _vm._v("閉じる"),
                      ]),
                    ]),
                  ]
                ),
              ]
            ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "eight wide column" }, [
      _c("h3", [_vm._v("宴会情報")]),
      _vm._v(" "),
      _c("table", { staticClass: "ui definition keyValueTable table" }, [
        _c("tr", [
          _c("td", [_vm._v("お問合せ番号")]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.marunage.code))]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("お問合せ日時")]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              _vm._s(_vm._f("formatDate")(_vm.marunage.event_date)) +
                " " +
                _vm._s(_vm.marunage.event_time)
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("希望エリア")]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.marunage.area_label))]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("エリア詳細")]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.marunage.area_detail_label))]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("希望日時")]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              _vm._s(_vm._f("formatDate")(_vm.marunage.event_date)) +
                " " +
                _vm._s(_vm.marunage.event_time)
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("人数")]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.marunage.people_label))]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("一人当たりの予算")]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.marunage.price_label))]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("希望条件など")]),
          _vm._v(" "),
          _c("td", { staticClass: "linebreak" }, [
            _vm._v(_vm._s(_vm.marunage.note)),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _vm._m(0),
          _vm._v(" "),
          _c("td", { staticClass: "linebreak" }, [
            _vm._v(_vm._s(_vm.marunage.message_for_shop)),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [
      _vm._v("コンシェルジュからの"),
      _c("br"),
      _vm._v("申し送り事項"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }